import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectIcon24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMediaObjectIcon24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.5 4.5H5c-.288 0-.557.081-.786.222l4.036 6.16 4.036-6.16A1.5 1.5 0 0 0 11.5 4.5M13 6.369 9.147 12.25l3.848 5.874Q13 18.063 13 18zM7.353 12.25 3.5 6.369V18q0 .063.005.124zM4.462 19.4l3.788-5.78 3.788 5.782q-.252.098-.538.099H5q-.286-.001-.538-.1M5 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h6.5a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm12 3.5A.75.75 0 0 0 17 8h4.227a.75.75 0 0 0 0-1.5zm-.75 4.25A.75.75 0 0 1 17 10h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectIcon24);
